module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0006-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "imagetoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Introduction",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION")])]), _c('br'), _c('br'), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Introduction#sugar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUGAR—THE PREQUEL!"), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("A BRIEF HISTORY OF THE WORLD (AS IT PERTAINS TO SUGAR)")])]), _c('br'), _c('br'), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Introduction#what",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WHAT YOU’LL NEED TO GET STARTED")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "imagetoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Section1#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIMPLE DISSOLVE TO THREAD STAGE")]), _c('br'), _vm._v("230°F–235°F"), _c('br'), _vm._v("(110°C–113°C)"), _c('br'), _c('em', [_vm._v("Sugar Concentration:")]), _c('br'), _vm._v("80%")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "imagetoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Section2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOFT-BALL STAGE")]), _c('br'), _vm._v("235°F–240°F"), _c('br'), _vm._v("(113°C–116°C)"), _c('br'), _c('em', [_vm._v("Sugar Concentration:")]), _c('br'), _vm._v("85%")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "imagetoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Section3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIRM-BALL STAGE")]), _c('br'), _vm._v("245°F–250°F"), _c('br'), _vm._v("(118°C–121°C)"), _c('br'), _c('em', [_vm._v("Sugar Concentration:")]), _c('br'), _vm._v("87%")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "imagetoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Section6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HARD-CRACK STAGE (AND BEYOND)")]), _c('br'), _vm._v("300°F–310°F"), _c('br'), _vm._v("(149°C–154°C)"), _c('br'), _c('em', [_vm._v("Sugar Concentration:")]), _c('br'), _vm._v("99%")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 72
// module chunks = 0